import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { ITermsAndConditionsPayload } from './TermsAndConditions.interface'
import { AxiosResponse } from 'axios'
import { updateTermsAndConditions } from './TermsAndConditions.service'

type IUpdateTermsAndConditionsProps = Partial<
	UseMutationOptions<
		AxiosResponse<ITermsAndConditionsPayload>,
		any,
		Partial<ITermsAndConditionsPayload>
	>
> & {
	id?: string
}
export function useUpdateTermsAndConditions({ id, ...rest }: IUpdateTermsAndConditionsProps = {}) {
	return useMutation<
		AxiosResponse<ITermsAndConditionsPayload>,
		any,
		Partial<ITermsAndConditionsPayload>
	>(
		async (data) => await updateTermsAndConditions(id, data),

		{
			...rest,
		},
	)
}
